import { attachmentSchema, type Attachment, type AttachmentId } from "@mailflare/shared";

import { apiRequest, apiRequestBlob } from "@/lib/api-client";

/** Uploads one file and returns its server-side metadata row. */
export async function uploadAttachment(file: File): Promise<Attachment> {
  const formData = new FormData();
  formData.append("file", file, file.name);
  return attachmentSchema.parse(
    await apiRequest<unknown>("/attachments", { method: "POST", formData }),
  );
}

export async function getAttachment(attachmentId: AttachmentId): Promise<Attachment> {
  return attachmentSchema.parse(
    await apiRequest<unknown>(`/attachments/${encodeURIComponent(attachmentId)}`),
  );
}

/** Downloads attachment bytes. Callers revoke the object URL when done. */
export async function getAttachmentContent(attachmentId: AttachmentId): Promise<Blob> {
  return apiRequestBlob(`/attachments/${encodeURIComponent(attachmentId)}/content`);
}
